import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
export interface IFileInfo {
  path: string,
  info: File
}
/**
 * ファイルアップロード
 *【ラベル内容:labelContent:string】
 *【選択ボタン内容:selectBtnText:string】
 *【アップロードボタン内容:uploadBtnText:string】
 *【ファイル:file:{path:string, info:File}】
 *【ファイルパス:filePath:string】
 *【許容ファイル:accept:string】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-file-upload-field',
  templateUrl: './file-upload-field.html',
  styles: [`
    
  `]
})
export class FileUploadField extends BaseWidget {
  /**
   * ファイルの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * ファイルに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 選択ボタン内容
   */
  @Input() selectBtnText:string

  /**
   * アップロードボタン内容
   */
  @Input() uploadBtnText:string

  /**
   * ファイル
   */
  @Input() file:{path:string, info:File}

  /**
   * ファイルパス
   */
  @Input() filePath:string

  /**
   * 許容ファイル
   */
  @Input() accept:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * fileUploadの子要素を設定する
   */
  get fileUpload() {
    const fileUpload = {
      label: this.labelContent,
      btnTxtReference: this.selectBtnText,
      btnTxtUpload: this.uploadBtnText,
      accept: this.accept
    }
    return fileUpload;
  }
  
  setFile(data) {
    let target = {} as IFileInfo;
    target.path = data.value;
    target.info = data.file;
    this.eventHub.next({
      id: this.id,
      type: data.event.type,
      source: data.file,
    });
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/file/file-upload-field/file-upload-field.component.ts